/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
  Box,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { ko } from "date-fns/locale";
import moment from "moment";
import GiftFindMember from './GiftFindMember';
import get_gift from "../lib/get_gift";
import get_token from "../lib/get_token";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function ReturnAdd(props) {

  const { open, setOpen, login, load_data } = props;
  const token = localStorage.getItem("token");
  const title = '사은품신청';
  const [openFindMember, setOpenFindMember] = useState(false); // 쿠폰찾기 팝업
  const [data, setData] = useState({ // 1
    mname: '',
    tmcd: '',
    amount: ''
  });
  const gift = get_gift();

  const handleChange = e => {
    setData(state => {
      let newState = state;
      newState[e.target.name] = e.target.value;
      return { ...newState };
    });
  }

  const onSubmit = async () => {
    let postData = {
      cid: login.cid,
      mcd: login.mcd,
      level: login.level,
      token: get_token(),
      tmcd: data.tmcd,
      amount: data.amount,
    }
    let result = await axios.post(configState.api + '/gympass_admin/gift_add', postData);
    if (result.data.success === 1) {
      setOpen(false);
      load_data();
    }
    else {
      Swal.fire('오류', result.data.msg);
      return;
    }
  }

  useEffect(() => {
    setData({
      mname: '',
      tmcd: '',
      amount: ''
    })
  }, [open]);

  // 
  // setOpen(false);
  // load_data(); // 부모창 새로고침
  // }

  return <>
    <GiftFindMember open={openFindMember}
      setOpen={setOpenFindMember}
      login={login}
      pHandleChange={handleChange}
    ></GiftFindMember>

    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="sm"
      TransitionComponent={Transition}
      onClose={() => setOpen(false)}
    >

      <AppBar sx={{ position: "static" }}>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Typography style={{ fontSize: 18 }}>{title}내역 추가</Typography>
          </Box>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => setOpen(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 1, mt: 2 }}>
        <Box display="flex">
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="mname"
            label="회원명"
            size="small"
            sx={{
              width: "120px",
            }}
            autoComplete="off"
            value={data.mname}
          ></TextField>
          <Box sx={{ ml: 1 }}>
            <Button
              variant="contained"
              onClick={() => {
                setOpenFindMember(true);
              }}
            >
              조회
            </Button>
          </Box>
        </Box>

        <Box marginTop={1}>
          <FormControl sx={{ width: 260 }} size="small">
            <InputLabel>사은품</InputLabel>
            <Select
              name="amount"
              label="사은품"
              onChange={handleChange}
              value={data.amount}
            >
              {gift.map((item, index) => {
                return <MenuItem value={item.count} key={index}>{item.title1} :: {item.title2}</MenuItem>
              })}
            </Select>
          </FormControl>
        </Box>

        <Box
          sx={{
            mt: 5, textAlign: "center"
          }}
        >
          <Button variant="contained" onClick={() => onSubmit()}>
            등록완료
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={() => setOpen(false)}
          >
            취소
          </Button>
        </Box>
      </Box>
    </Dialog>
  </>
}

export default ReturnAdd;